import './css/CustomerDetail.css'

import { Fragment, useEffect, useState } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import { Button, Space, Row } from 'antd'
import { baseAxiosNoInfo } from '../../tool/axios'
import _ from 'lodash'

import AddHospitalEscort from './components/AddHospitalEscort'
import AddNursing from './components/AddClubNursing'
import UpdateHospitalEscort from './components/UpdateHospitalEscort'
import UpdateNursing from './components/UpdateNursing'
import DownHospitalEscort from './components/OperateDownHospitalEscort'
import OperateOrderAdvance from './components/OperateNursingOrderAdvance'

import CustomerInfo from './components/ClubCustomerInfo'
import CustomerCheckInInfo from './components/ClubCustomerCheckInInfo'
import CustomerBabyInfo from './components/ClubCustomerBabyInfo'
import CustomerServiceInfo from './components/ClubCustomerServiceInfo'

import RecordCheckInDetail from './components/RecordCheckInDetail'
import RecordNursingWork from './components/RecordNursingWork'
import RecordNursingWorkDetail from './components/RecordNursingWorkDetail'

interface client {
    check_in_status: number  // 入住状态，0待分配 1已预订 2已入住 3已出所
    check_in_pay_desc: string, // 入住付款状态描述
    check_in_id: string // 入住标识
    check_in_store_name: string // 入住门店
    check_in_user_name: string // 客人姓名
    check_in_phone: string // 手机号码
    preg_status_desc: string // 怀孕时期
    expect_born_day: string // 预产期
    actually_born_day: string // 分娩日
    check_in_time: string // 实际入住时间
    check_out_time_init: string // 预计出所时间
    check_out_time_finally: string // 实际出所时间
    emergency_man_name: string // 紧急联系人
    emergency_phone: string // 紧急联系人手机号
    accompany_man_name: string // 陪护人
    accompany_phone: string // 陪护人手机号
    check_in_total_days: number // 入住总天数
    check_in_already_days: number // 已入住天数
    check_in_left_days: number // 剩余天数
    deal_id: string // 签单标识
    store_id: string // 签单门店标识
    deal_item_name: string // 签单套餐名称
    item_days: number // 套餐天数
    gift_days: number // 赠送天数
    nursing_care_type_desc: string // 护理模式
    hospital_escort_days: number // 医院陪护天数
}

interface checkInRecord {
    room_type_name: string,
    room_number: string,
    check_in_day_range: string
}

interface person {
    check_in_id: string
    belong_minion_id: string // 责任管家id
    belong_minion_name: string, // 责任管家名称
    belong_cleaner_id: string, // 生活助理（保洁）id
    belong_cleaner_name: string, // 生活助理（保洁）名称
    belong_nurse_id: string, // 责任护士id
    belong_nurse_name: string, // 责任护士名称，冗余字段
    belong_dietician_id: string, // 营养师id
    belong_dietician_name: string, // 营养师名称
    belong_recover_id: string, // 产康师id
    belong_recover_name: string, // 产康师名称
    belong_look_after_id: string, // 护理师id
    belong_look_after_name: string, // 护理师名称
}

interface serviceRecord {
    work_id: string, // 上单标识
    nursing_care_type: number // 护理模式
    nursing_care_type_desc: string // 护理模式描述
    belong_nursing_name: string  // 护理师
    service_status: number // 服务状态
    service_start_date: string // 服务开始日期
    service_end_date: string // 服务结束日期
    service_days: number // 服务天数
}

export default function () {

    const [tabCurrent, setTabCurrent] = useState<number>(0)
    const [clientData, setClientData] = useState<client>()
    const [checkInRecordData, setCheckInRecordData] = useState<checkInRecord[]>([])
    const [servicedata, setServiceData] = useState<person>()

    const [inService, setInService] = useState<serviceRecord>()
    const [inHospitalService, setInHospitalService] = useState<serviceRecord>()

    const param: { id: string } = useParams()
    const [statusStr, setStatusStr] = useState<string>('')

    const history = useHistory()

    useEffect(() => {
        getClientInfo()
        getCheckInRecord()
        getServiceInfo()
    }, [])

    // 查询客户信息
    const getClientInfo = () => {
        baseAxiosNoInfo('/keeper/check_in/detail/base_info', {
            params: {
                check_in_id: param.id
            }
        }).then((res: any) => {
            if (res) {
                setClientData(res)

                switch (res.check_in_status) {
                    case 1:
                        setStatusStr('已预订')
                        break
                    case 2:
                        setStatusStr('已入住')
                        break
                    case 3:
                        setStatusStr('已出所')
                        break
                }

                baseAxiosNoInfo('/yuesao_center/customer/detail/nursing_work_records', {
                    params: {
                        deal_id: res.deal_id
                    }
                }).then((res: any) => {
                    if (res) {
                        let params: any = _.cloneDeep({
                            service_status: 3
                        })
                        setInService(params)

                        res.forEach((el: any) => {
                            if (el.service_status !== 2) return;

                            if (el.nursing_care_type === 2 || el.nursing_care_type === 3) {
                                // 托管/一对一
                                setInService(el)
                            }
                        })

                        const inServiceRecord = findRecordByStatus(res, 1, 2)

                        if (inServiceRecord) {
                            setInHospitalService(inServiceRecord)

                        } else if (isAllStatusByCareType(res, 1, 3)) {
                            const latestRecord = getLatestRecordByCareType(res, 1)

                            if (latestRecord) {
                                setInHospitalService(latestRecord)
                            }
                        }
                    }
                })
            }
        })
    }

    // 查询入住信息
    const getCheckInRecord = () => {
        baseAxiosNoInfo('/keeper/check_in/detail/room_info', {
            params: {
                check_in_id: param.id
            }
        }).then((res: any) => {
            if (res) {
                setCheckInRecordData(res)
            }
        })
    }

    // 查询服务人员信息
    const getServiceInfo = () => {
        baseAxiosNoInfo('/keeper/check_in/detail/service_employee_info', {
            params: {
                check_in_id: param.id
            }
        }).then((res: any) => {
            res && setServiceData(res)
        })
    }

    // 查找护理类型的第一条记录
    const findRecordByStatus = (
        list: any[],
        careType: number,
        serviceStatus: number
    ): any | undefined => {
        return list.find(el =>
            el.nursing_care_type === careType && el.service_status === serviceStatus
        )
    }

    // 判断护理类型的状态
    const isAllStatusByCareType = (
        list: any[],
        careType: number,
        serviceStatus: number
    ): boolean => {
        const filtered = list.filter(el => el.nursing_care_type === careType)
        return filtered.length > 0 && filtered.every(el => el.service_status === serviceStatus)
    }

    // 获取护理类型的最新记录
    const getLatestRecordByCareType = (
        list: any[],
        careType: number,
        timeField: string = 'create_time'
    ): any | undefined => {
        const filtered = list.filter(el => el.nursing_care_type === careType)
        if (filtered.length === 0) return undefined

        return [...filtered].sort((a, b) =>
            new Date(b[timeField]).getTime() - new Date(a[timeField]).getTime()
        )[0]
    }

    return <div className="common-level2-edit h-detail">
        {/* 月嫂中心 -> 客户管理 -> 会所客户管理 -> 客户详情 */}
        <p className="modules-h2">客户详情</p>

        <div className="clear" style={{ paddingLeft: 16, marginBottom: 16 }} >
            <Button size="small" onClick={() => {
                history.replace({
                    pathname: '/yuesao_clubhouse_manage',
                    state: history.location.state
                })
            }} >返回</Button>
        </div>

        {/* 医院陪护 */}
        {inHospitalService?.service_status == 2 && <Space direction="horizontal" wrap>
            <Row gutter={20} style={{ marginLeft: 12, marginBottom: 12 }}>
                {/* 更换医院陪护 */}
                <UpdateHospitalEscort serviceRecord={inHospitalService} onChange={() => {
                    getClientInfo()
                    getServiceInfo()
                }} />

                {/* 下单医院陪护 */}
                <DownHospitalEscort serviceRecord={inHospitalService} onChange={() => {
                    getClientInfo()
                }} />
            </Row>
        </Space>}

        {/* 已预定 */}
        {clientData?.check_in_status === 1 && inHospitalService == null && <Space direction="horizontal" wrap>
            <Row gutter={20} style={{ marginLeft: 12, marginBottom: 12 }}>
                {/* 分配医院陪护 */}
                <AddHospitalEscort clientData={clientData} onChange={() => {
                    getClientInfo()
                    getCheckInRecord()
                }} />
            </Row>
        </Space>}

        {/* 已入住 */}
        {(clientData?.check_in_status === 1 || clientData?.check_in_status === 2) && <Space direction="horizontal" wrap>
            <Row gutter={20} style={{ marginLeft: 12, marginBottom: 12 }}>
                {/* 分配护理师 */}
                {!servicedata?.belong_look_after_id &&
                    <AddNursing onChange={() => {
                        getClientInfo()
                        getServiceInfo()
                    }} />
                }

                {/* 更换护理师 */}
                {(servicedata?.belong_look_after_id && inService?.service_status == 2) &&
                    <UpdateNursing serviceRecord={inService} onChange={() => {
                        getClientInfo()
                        getServiceInfo()
                    }} />
                }

                {/* 提前下单 */}
                {(servicedata?.belong_look_after_id && inService?.service_status == 2) &&
                    <OperateOrderAdvance serviceRecord={inService} onChange={() => {
                        getClientInfo()
                        getServiceInfo()
                    }} />
                }
            </Row>
        </Space>}

        {/* 客户信息 */}
        <CustomerInfo status={statusStr} data={clientData} onChange={() => {
            getClientInfo()
            getCheckInRecord()
            getServiceInfo()
        }} />

        {/* 入住信息 */}
        <CustomerCheckInInfo status={statusStr} data={checkInRecordData} onFetched={() => {
            getClientInfo()
            getCheckInRecord()
        }} />

        {/* 宝宝信息 */}
        <CustomerBabyInfo status={statusStr} />

        {/* 服务人员信息 */}
        <CustomerServiceInfo status={statusStr} serviceData={servicedata} onChange={() => {
            getClientInfo()
            getCheckInRecord()
            getServiceInfo()
        }} />

        <Space direction="horizontal" wrap className="tab clear" style={{ width: '95%' }}>
            <div className={tabCurrent === 0 ? 'tab-btn fl current' : 'tab-btn fl'} onClick={() => { setTabCurrent(0) }}>入住记录</div>
            <div className={tabCurrent === 1 ? 'tab-btn fl current' : 'tab-btn fl'} onClick={() => { setTabCurrent(1) }}>服务记录</div>

            {(clientData?.check_in_status === 2 || clientData?.check_in_status === 3) && <Fragment>
                <div className={tabCurrent === 2 ? 'tab-btn fl current' : 'tab-btn fl'} onClick={() => { setTabCurrent(2) }}>服务操作记录</div>
            </Fragment>}
        </Space>

        <div className="tab-cont">
            {tabCurrent === 0 ? <div className="cont">
                <RecordCheckInDetail />
            </div> : null}
            {tabCurrent === 1 ? <div className="cont">
                <RecordNursingWork dealID={clientData?.deal_id} />
            </div> : null}

            {(clientData?.check_in_status === 2 || clientData?.check_in_status === 3) && <Fragment>
                {tabCurrent === 2 ? <div className="cont">
                    <RecordNursingWorkDetail dealID={clientData?.deal_id} />
                </div> : null}
            </Fragment>}
        </div>
    </div>
}